import React, { useState, useEffect } from 'react';


/**
 * Component that displays the build info which is served up by the app as
 * a static file (buildInfo.json).  This file is generated by the pipeline
 * (see backend repo for pipeline IaC) based on the npm version (frontendVersion)
 * and the auto-generated buildNumber controlled by AWS Code Build.
 * @component
 */
const BuildInfo = () => {
  const [buildVersion, setbuildVersion] = useState(null);

  useEffect(() => {
    const fetchBuild = async () => {
      try {
        const response = await fetch('/buildInfo.json');
        const data = await response.json();
        setbuildVersion(data);
      } catch (error) {
        console.log('Error fetching buildInfo.json', error);
      }
    };

    fetchBuild();
  }, []);

  return (
    <div>
      { buildVersion &&
        <div>{`v${buildVersion.frontendVersion}.${buildVersion.buildNumber}.${buildVersion.packageVersion}`}</div>
      }
    </div>
  );

}

export default BuildInfo;